import { Box, Grid } from '@mui/material';
import { ModalName } from 'app/enums';
import { TournamentPlayerEntity } from 'app/interfaces/entity';
import { modalsReducers } from 'app/store/modal/slice';
import { TournamentTeamPlayerCard } from 'modules/tournaments/components/BracketTournament/TournamentTeams/TournamentTeamPlayerCard';
import { currentTournamentSelector } from 'modules/tournaments/store/current-tournament/selectors';
import React, { FC, useCallback, useMemo } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { EmptyUserCard } from 'shared/components/EmptyUserCard';
import { CardAction } from 'shared/interfaces';
import { useStyles } from './MyTeamPlayersList.styles';

interface MyTeamListProps {
  teamSize: number;
  players: TournamentPlayerEntity[];
  playerCardActions?: CardAction<TournamentPlayerEntity>[];
}

export const MyTeamPlayersList: FC<MyTeamListProps> = ({
  teamSize,
  players,
  playerCardActions,
}) => {
  const dispatch = useDispatch();
  const { classes } = useStyles();
  const isCurrentUserCaptain = useSelector(currentTournamentSelector.isCurrentUserCaptain);

  const playersToInvite = useMemo(() => {
    const playersToInviteCount = teamSize - players.length;
    if (!teamSize || playersToInviteCount < 0) {
      return [];
    }

    return new Array(playersToInviteCount).fill(0);
  }, [players.length, teamSize]);

  const openInviteModal = useCallback(() => {
    if (!isCurrentUserCaptain) {
      return;
    }

    dispatch(modalsReducers.openModal({ name: ModalName.SearchUsers }));
  }, [dispatch, isCurrentUserCaptain]);

  return (
    <Grid container spacing={2} className={classes.container}>
      {players.map((player, index) => (
        <Grid item key={`${player?.user?.id}-${index}`}>
          <Box className={classes.card}>
            <TournamentTeamPlayerCard
              player={player}
              playerCardActions={playerCardActions}
              p={1.875}
            />
          </Box>
        </Grid>
      ))}
      {playersToInvite.map((_, index) => (
        <Grid item key={index}>
          <EmptyUserCard title="Invite" onClick={openInviteModal} p={1.875} />
        </Grid>
      ))}
    </Grid>
  );
};
